<template>
  <div class="card card-chat-booking float-left ml-3">
    <div class="card-body">
      <div class="mb-3">
        <b>{{ message.text }}</b>
      </div>
      <div class="form-group">
        <input name="name"
               type="text"
               class="form-control"
               :class="{'form-alert': errors.has('name')}"
               placeholder="ชื่อที่พัก"
               v-model="userPlace.place_name"
               v-validate="'required'">
        <div v-show="errors.has('name')" class="text-remark pt-1 text-danger">{{ $t('message.required_field') }}</div>
      </div>

      <div class="form-group">
        <select name="place_size_id"
                class="form-control"
                :class="{'form-alert': errors.has('place_size_id')}"
                v-model="userPlace.place_size_id"
                v-validate="'required'">
          <option :value="null">กรุณาเลือกประเภทที่พัก</option>
          <option v-for="placeSize, index in sortedPlaceSizes" :value="sortedPlaceSizes[index].id">
            {{ placeSize | multiLangName }}
          </option>
        </select>
        <div v-show="errors.has('place_size_id')" class="text-remark pt-1 text-danger">{{ $t('message.required_selection') }}</div>
      </div>
      <hr>
      <div class="form-group">
        <textarea
          name="address"
          rows="2"
          :placeholder="$t('message.my_listings.location_placeholder')"
          class="form-control"
          :class="{'form-alert': errors.has('address')}"
          v-validate="'required'"
          v-model="userPlace.address"></textarea>
        <div v-show="errors.has('address')" class="text-remark pt-1 text-danger">{{ $t('message.required_field') }}</div>
      </div>

      <div class="form-group">
        <select name="province_id"
                class="form-control"
                :class="{'form-alert': errors.has('province_id')}"
                v-model="userPlace.address_province_id"
                v-validate="'required'">
          <option :value="null">{{ $t('message.booking.contact_step.set_province') }}</option>
          <option :value="addressProvince.id" v-for="addressProvince, index in sortedProvinces">
            {{ addressProvince | multiLangName }}
          </option>
        </select>
        <div v-show="errors.has('province_id')" class="text-remark pt-1 text-danger">{{ $t('message.required_selection') }}</div>
      </div>

      <div class="form-group">
        <select name="district_id"
                class="form-control"
                :class="{'form-alert': errors.has('district_id')}"
                v-model="userPlace.district_id"
                v-validate="'required'">
          <option :value="null">{{ $t('message.booking.contact_step.set_district') }}</option>
          <option :value="district.id" v-for="district, index in sortedDistricts">
            {{ district | multiLangName }}
          </option>
        </select>
        <div v-show="errors.has('district_id')" class="text-remark pt-1 text-danger">{{ $t('message.required_selection') }}</div>
      </div>

      <div class="form-group">
        <textarea
          id="remark"
          :placeholder="$t('message.my_listings.remark_placeholder')"
          rows="2"
          class="form-control"
          v-model="userPlace.remark"></textarea>
      </div>

      <section class="py-3">
        <pet-selection-label/>
        <div class="d-flex justify-content-center align-items-center pt-2">
          <div class="flex-fill">
            <label><i class="fas fa-paw"></i> {{ $t('message.booking.contact_step.pet_remark') }}</label>
          </div>
          <div>
            <toggle-button v-model="switchHasPet" 
                          :sync="true"
                          color="#8BC34A"
                          @change="onChangeHasPet"/>
          </div>
        </div>
        <div class="d-flex justify-content-start align-items-center flex-wrap" v-if="selectedPetTypes">
          <div v-for="petType in selectedPetTypes">
            <div class="d-flex justify-content-start align-items-center border border-chip-gray rounded-pill px-2 py-1 mr-2 mb-2">
              <div class="pr-2" v-if="petType.image_url">
                <img :src="petType.image_url" width="24">
              </div>
              <div>{{ petType | multiLangName }} <span v-if="petType.remark">:{{ petType.remark }}</span></div>
            </div>
          </div>
        </div>
      </section>

      <div>
        <label>{{ $t('message.booking.contact_step.location') }}</label>
        <div class="card my-0" :class="[ errors.has('location') ? 'border-danger' : 'border-divider' ]">
          <div class="card-body p-2">
            <div class="d-flex justify-content-start align-items-center">
              <div class="flex-fill">
                <span v-if="userPlace.latitude && userPlace.longitude">
                  <i class="fal fa-check-circle text-success fa-lg"></i>&nbsp;&nbsp;{{ $t('message.booking.contact_step.pinned_location') }}
                </span>
                <span v-else>
                  <i class="fal fa-exclamation-circle text-danger fa-lg"></i>&nbsp;&nbsp;{{ $t('message.booking.contact_step.unpinned_location') }}
                </span>
              </div>
              <div>
                <button class="btn btn-outline-info" @click="openPinlocationModal()">
                  {{ (userPlace.latitude && userPlace.longitude) ? $t('message.button.edit') : $t('message.button.add') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="text-remark -status-alert mt-1" v-if="errors.has('location')">
          {{ $t('message.required_field') }}
        </div>
      </div>

      <div class="form-group mt-3" v-if="!saveSuccess">
        <button class="btn btn-block btn-info" :disabled="loading" @click="submit">ยืนยัน</button>
        <button class="btn btn-block btn btn-outline-secondary" @click="cancel">ยกเลิก</button>
      </div>

      <div class="text-center mt-4" v-else>
        <h3>
          <i class="fas fa-check-circle -status-accepted"></i> บันทึกข้อมูลสำเร็จ
        </h3>
      </div>
    </div>
    <!-- Pin location modal -->
    <pin-location-modal :settings="settings" ref="pinLocationModal" @savedLocation="setLocation" />
    <pet-type-modal ref="petTypeModal" @onUpdateResult="updateUserPlacePetTypes" />
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import axios from 'axios'
  import userPlaceHelpers from '../../../helpers/userPlaceHelpers'
  import PinLocationModal from '../../booking/components/PinLocationModal'
  import PetSelectionLabel from '../../booking/components/PetSelectionLabel'
  import PetTypeModal from '../../booking/components/PetTypeModal'

  export default {
    props: {
      message: Object
    },
    components: {
      PetSelectionLabel,
      PetTypeModal,
      PinLocationModal
    },
    data () {
      return {
        userPlace: {
          user_id: null,
          place_name: null,
          place_size_id: null,
          address: null,
          address_province_id: null,
          district_id: null,
          remark: null,
          has_pet: null,
          pet_remark: null,
          latitude: null,
          longitude: null
        },
        sortBy: 'name_th',
        loading: false,
        saveSuccess: false,
        settings: {
          page: 'checkout',
          hideHeaderClose: false,
          noCloseOnBackdrop: false,
          okOnly: false
        },
        switchHasPet: false,
        selectedPetTypes: null,
        isClearing: false
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        user: 'auth/getUser'
      }),
      ...mapState('chatBooking', ['messages', 'bookingData']),
      ...mapState('addressProvince', ['addressProvinces', 'districts']),
      sortedPlaceSizes () {
        return this._.orderBy(this.globalState.placeSizes, ['id'], ['asc'])
      },
      sortedProvinces () {
        return this._.orderBy(this.addressProvinces, [this.sortBy], ['asc'])
      },
      sortedDistricts () {
        return this._.orderBy(this.districts, [this.sortBy], ['asc'])
      }
    },
    watch: {
      'userPlace.address_province_id': function (newVal, oldVal) {
        this.fetchDistricts(newVal)
        this.userPlace.district_id = null
      }
    },
    methods: {
      async onChangeHasPet (event) {
        if (event.value) {
          this.$refs.petTypeModal.showModal(true)
        } else {
          // clear data
          this.selectedPetTypes = null
          this.userPlace.has_pet = 0
        }
      },
      updateUserPlacePetTypes (data) {
        // update switch
        this.switchHasPet = data.hasPet
        // update user place data
        const hasPet = (data.hasPet) ? 1 : 0
        this.userPlace.has_pet = hasPet
        this.selectedPetTypes = null
        if (data.selectedPetTypes) {
          this.selectedPetTypes = data.selectedPetTypes
        }
      },
      setLocation (data) {
        this.userPlace.latitude = data.latitude
        this.userPlace.longitude = data.longitude
        this.$validator.errors.remove('location')
      },
      openPinlocationModal () {
        let provinceId = 1
        let lat = this.globalState.citiesLocations[provinceId].lat
        let lng = this.globalState.citiesLocations[provinceId].lng
        let isInit = true
        if (!this.userPlace.latitude || !this.userPlace.longitude) {
          if (this.userPlace.address_province_id) {
            for (const addressProvince of this.addressProvinces) {
              if (addressProvince.id === this.userPlace.address_province_id) {
                provinceId = addressProvince.province_id
                break
              }
            }
            lat = this.globalState.citiesLocations[provinceId].lat
            lng = this.globalState.citiesLocations[provinceId].lng
          }
        } else {
          isInit = false
          lat = this.userPlace.latitude
          lng = this.userPlace.longitude
        }
        this.$refs.pinLocationModal.show(lat, lng, isInit)
      },
      sendMessage (action) {
        const message = {
          sender_type: 'user',
          type: 'text',
          label: action.label,
          text: action.text,
          data: action.data
        }
        this.$store.commit('chatBooking/ADD_MESSAGE', message)
      },
      submit () {
        if (!this.userPlace.latitude || !this.userPlace.latitude) {
          this.$validator.errors.add({ field: 'location', msg: 'no location' })
        }
        this.$validator.validate().then(valid => {
          if (valid) {
            this.loading = true
            const url = '/users-places/save-from-chat'
            const submitData = this.userPlace
            if (this.selectedPetTypes) {
              const petTypeIds = this.selectedPetTypes.map(petType => petType.id)
              submitData.pet_type_ids = petTypeIds
              // Get pet type remark
              const otherPet = this.selectedPetTypes.find(petType => petType.is_other === 1)
              if (otherPet && otherPet.remark) {
                submitData.pet_type_remark = otherPet.remark
              }
            }
            axios.post(url, submitData)
              .then(res => {
                const response = res.data
                this.loading = false
                if (!response.error) {
                  this.saveSuccess = true
                  const userPlace = response.user_place
                  const fullAddress = userPlaceHelpers.getFullAddress(userPlace)
                  let data = `user_place_id=${userPlace.id}&place_name=${userPlace.place_name}&place_size_id=${userPlace.place_size_id}&province_id=${userPlace.province_id}`
                  if (userPlace.address_province_id) {
                    data += `&address_province_id=${userPlace.address_province_id}`
                  }
                  if (userPlace.district_id) {
                    data += `&district_id=${userPlace.district_id}`
                  }
                  if (userPlace.sub_district_id) {
                    data += `&sub_district_id=${userPlace.sub_district_id}`
                  }
                  const message = {
                    sender_type: 'user',
                    type: 'text',
                    label: 'selected-user-place',
                    text: userPlace.place_name,
                    optional_text: fullAddress,
                    data: data
                  }
                  this.$store.commit('chatBooking/ADD_MESSAGE', message)
                }
              })
              .catch(error => {
                this.loading = false
                console.log(error)
                this.$swal({text: error.message, type: 'error'})
              })
          }
        })
      },
      cancel () {
        const action = {
          label: 'cancel-user-place',
          text: 'ยกเลิก'
        }
        this.sendMessage(action)
      },
      fetchAddressProvinces () {
        this.$store.dispatch('addressProvince/LOAD_ADDRESS_PROVINCES')
      },
      fetchAddressProvincesDistricts () {
        this.$store.dispatch('addressProvince/LOAD_ADDRESS_PROVINCES_DISTRICTS', {province_id: this.bookingData.province_id})
      },
      fetchDistricts (provinceId) {
        if (provinceId) {
          const queryData = {
            province_id: provinceId
          }
          this.$store.dispatch('addressProvince/LOAD_DISTRICTS', queryData)
        }
      }
    },
    mounted () {
      this.userPlace.user_id = this.user.id
      // Route B: start with select professional
      if (this.bookingData.route === 'select-professional-first' && this.bookingData.province_id) {
        this.fetchAddressProvincesDistricts()
      } else {
        this.fetchAddressProvinces()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/UserPlaceMessage.vue